import { connect } from 'react-redux'

import { doFetchCannedReplyCategoriesAndTemplatesBySearch } from 'ducks/cannedReplies/operations'
import { debounce } from 'util/functions'

import View from './view'

const perform = dispatch => ({
  onSearchChange: debounce(
    query => dispatch(doFetchCannedReplyCategoriesAndTemplatesBySearch(query)),
    175
  ),
})

export default connect(null, perform)(View)
